import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { compose } from "recompose";

import "./SignIn.css";

import { withFirebase } from "../Firebase";
import * as ROUTES from "../../constants/routes";

const SignInPage = () => (
  <div>
    <SignInForm />
  </div>
);

const INITIAL_STATE = {
  email: "",
  password: "",
  error: null
};

class SignInFormBase extends Component {
  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
  }

  onSubmit = event => {
    console.log("Form Submit Entered");
    const { email, password } = this.state;

    this.props.firebase
      .doSignInWithEmailAndPassword(email, password)
      .then(() => {
        this.setState({ ...INITIAL_STATE });
        this.props.history.push(ROUTES.LIST_USERS);
      })
      .catch(error => {
        this.setState({ error });
        console.log("Error in auth");
      });

    event.preventDefault();
    console.log("Form Submit Completed!");
  };

  onChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  render() {
    const { email, password, error } = this.state;
    const isInvalid = password === "" || email === "";
    return (
      <div>
        <div className="container">
          <div className="row">
            <div className="col-lg-3 content_center">
              <h1 className="form-heading">login Form</h1>
              <div className="login-form">
                <div className="">
                  <div className="panel">
                    <h2>Admin Login</h2>
                    <p>Please enter your email and password</p>
                  </div>
                  <form onSubmit={this.onSubmit}>
                    <div className="form-group">
                      <input
                        name="email"
                        value={email}
                        onChange={this.onChange}
                        type="email"
                        className="form-control"
                        id="inputEmail"
                        placeholder="Email Address"
                      />
                    </div>
                    <div className="form-group">
                      <input
                        name="password"
                        value={password}
                        onChange={this.onChange}
                        type="password"
                        className="form-control"
                        id="inputPassword"
                        placeholder="Password"
                      />
                    </div>
                    <div className="forgot">
                      <a href={ROUTES.PASSWORD_FORGET}>Forgot password?</a>
                    </div>
                    <button
                      disabled={isInvalid}
                      type="submit"
                      className="btn btn-primary"
                    >
                      Login
                    </button>
                    <hr />
                    {error && (
                      <div className="alert alert-danger" role="alert">
                        {error.message}
                      </div>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const SignInForm = compose(
  withRouter,
  withFirebase
)(SignInFormBase);

export default SignInPage;

export { SignInForm };
